import { api } from "./api";

export const getBranchData = async (addUrl = "") => {
  let url = `/branch/main/branch?${addUrl}`;
  return await api.get(url);
};

export const BranchStatusUpdate = async (branch_id, status) => {
  return await api.get(
    `/branch/status/update?branch_id=${branch_id}&status=${status}`
  );
};

export const branchTransferStudents = async (data) => {
  return await api.post("/branch/student/transfer", data);
};

export const transferList = async (addUrl = "") => {
  return await api.get(`/branch/student/transfer/list?${addUrl}`);
};

export const branchStudentDelete = async (id) => {
  return await api.get(`/branch/student/delete?id=${id}`);
};

export const branchStudentUpdate = async (data) => {
  return await api.post("/branch/student/update", data);
};
